<div
  class="loading-wrapper"
  [ngClass]="{ 'loading-active': isLoading$ | async }"
>
  <div class="loading-container">
    <div class="loading-box">Loading...</div>
  </div>
</div>
